import gql from 'graphql-tag';

export const TRACK = gql`
  mutation Track($data: AnalyticEvent!) {
    track(data: $data) {
      id
      success
      event
    }
  }
`;

export const EMIT_EVENT = gql`
  mutation Emit($data: EmittableEvent!) {
    emit(data: $data) {
      id
      success
    }
  }
`;
